// ============================================================================
// VIRTUAL TREE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'virtual-tree',
  name: 'Virtual Tree',
  category: 'Graphs',
  complexity: {
    time: 'O(K log K)',
    space: 'O(K)'
  },
  description: 'A compressed representation of a tree containing only the vertices of interest (K vertices) and their lowest common ancestors. Used to solve problems that only require operations on a subset of tree vertices.'
};
